<script setup lang="ts">
import { onMounted } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useNabooContentStore } from '@/presentation/stores/content/nabooContent.ts'
import { storeToRefs } from 'pinia'
import CNabooContentListCourses from '@/presentation/components/content/CNabooContentListCourses.vue'
import CBaseHeader from '@/presentation/components/base/CBaseHeader.vue'
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'

// SERVICES
const toast = useToast()

// STORES
const { fetchNabooContent } = useNabooContentStore()
const { listAxis } = storeToRefs(useNabooContentStore())

onMounted(async () => {
  try {
    await fetchNabooContent()
  } catch (error) {
    if (error instanceof Error) {
      toast.add({ severity: 'error', summary: 'Erreur', detail: error.message })
    } else {
      toast.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Une erreur est survenue, merci de contacter le support'
      })
    }
  }
})
</script>

<template>
  <c-base-header title="Liste des contenus Naboo" :display-breadcrumbs="false" />

  <div class="gap-8 overflow-y-auto p-8 pt-2">
    <div class="flex flex-col gap-4">
      <c-base-block
        v-for="axis in listAxis"
        :key="`axis_${axis.id}`"
        :title="axis.title"
        toggleable
      >
        <c-naboo-content-list-courses :learning-courses="axis.learningCourses" />
      </c-base-block>
    </div>
  </div>
</template>
